/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Button } from 'ui';
import LinkButton from 'components/shared/LinkButton';
import request from 'utils/request_ajax';
import { routes } from '../../constants/config';

class SubscriptionForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscription_type: props.subscriptionType,
      ...props.subscription,
      errors: [],
      loading: false,
    };
  }

  handleSubmit = () => {
    this.setState({ loading: true });
    if (this.props.subscription.id) {
      this.updateSubscription();
    } else {
      this.createSubscription();
    }
  };

  handleChange = event => {
    const { name, value, type, checked } = event.target;
    const finalValue = type === 'checkbox' ? checked : value;
    this.setState({ [name]: finalValue });
  };

  handleSubscriptionEventChange = event => {
    const { name } = event.target;
    const subEvents = [...this.state.events];
    let finalEvents;

    if (subEvents.includes(name)) {
      finalEvents = subEvents.filter(evnt => evnt !== name);
    } else {
      finalEvents = [...subEvents, name];
    }

    this.setState({
      events: finalEvents,
    });
  };

  createSubscription() {
    request
      .post(routes.NOTIFICATION_SUBSCRIPTIONS, {
        notification_subscription: { ...this.state },
      })
      .then(payload => this.props.onCancel())
      .fail(failPayload => {
        this.setState({
          errors: failPayload.responseJSON.errors,
          loading: false,
        });
      });
  }

  updateSubscription() {
    request
      .put(routes.NOTIFICATION_SUBSCRIPTION(this.props.subscription.id), {
        notification_subscription: { ...this.state },
      })
      .then(() => this.props.onCancel())
      .fail(failPayload => {
        this.setState({
          errors: failPayload.responseJSON.errors,
          loading: false,
        });
      });
  }

  render() {
    return (
      <div className="p-16 form-horizontal">
        <input
          type="hidden"
          id="type"
          name="subscription_type"
          value={this.state.subscription_type}
        />

        <div>
          <input
            type="checkbox"
            id="subscribed"
            name="subscribed"
            checked={this.state.subscribed}
            onChange={this.handleChange}
          />
          &nbsp;
          <label htmlFor="subscribed">
            {t('settings.tab.api_webhook.event_subscription.enable')}
          </label>
        </div>

        <p>
          <label htmlFor="url">
            {t('settings.tab.api_webhook.event_subscription.payload_url')}
          </label>
          <input
            type="url"
            id="url"
            name="url"
            className="form-control SettingsContent-fullWidthInput"
            value={this.state.url}
            onChange={this.handleChange}
            placeholder="https://example.com/route"
            required
          />
          {this.state.errors.url &&
            this.state.errors.url.map(error => (
              <span key={error} className="c-red">
                {error}
              </span>
            ))}
        </p>

        <p>
          <label htmlFor="token">
            {t('settings.tab.api_webhook.event_subscription.token')}
          </label>
          <input
            type="text"
            id="token"
            name="token"
            className="form-control SettingsContent-fullWidthInput"
            value={this.state.token}
            onChange={this.handleChange}
            required
          />
          {this.state.errors.token &&
            this.state.errors.token.map(error => (
              <span key={error} className="c-red">
                {error}
              </span>
            ))}
        </p>

        <p>
          <label htmlFor="version">
            {t('settings.tab.api_webhook.event_subscription.version')}
          </label>
          <select
            className="form-control SettingsContent-input"
            value={this.state.version}
            onChange={this.handleChange}
          >
            <option value="1">1</option>
          </select>
        </p>

        {this.props.events && (
          <h3 className="SettingsContent-heading">
            {t('settings.tab.api_webhook.event_subscription.events')}
          </h3>
        )}
        {this.props.events &&
          this.props.events.map(event => (
            <span key={event}>
              <input
                type="checkbox"
                id={event}
                name={event}
                checked={this.state.events.includes(event)}
                onChange={this.handleSubscriptionEventChange}
              />
              &nbsp;
              <label htmlFor={event}>{event}</label>
              &nbsp;&nbsp;
            </span>
          ))}

        <div className="mt-10">
          <Button
            onClick={this.handleSubmit}
            primary
            disabled={this.state.loading}
            loading={this.state.loading}
          >
            {t('settings.tab.api_webhook.event_subscription.save')}
          </Button>
          &nbsp;&nbsp;
          <LinkButton type="primary" onClick={this.props.onCancel}>
            {t('settings.tab.api_webhook.event_subscription.cancel')}
          </LinkButton>
        </div>
      </div>
    );
  }
}

export default SubscriptionForm;
